import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Cell, DataBlock, Grid } from '@fs/zion-ui'
import { PersonLink, TreePersonLink, UserLink } from '../../../app/Links'
import { isNullOrUndefined } from '../../../../util/Utils'
import { LabelsBlock, OriginalAndStandardFactBlock } from '../../commonComponents/CommonComponents'
import { TreeIdCells } from './TreeIdBlock'

export default () => {}

export function TransitionMessageSummary({ messageDetails, queueCachesState, queueCachesActions }) {
  const { t } = useTranslation()
  const personId = messageDetails?.personId

  const personSummary = queueCachesState.personsCache[personId]
  const personLabels = queueCachesState.labelsCache[personId]
  const userSummary = queueCachesState.usersCache[personSummary?.creatorContributorId]

  useEffect(() => {
    queueCachesActions.fetchPersonSummary(personId)
    queueCachesActions.fetchPersonLabels(personId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    personSummary?.creatorContributorId && queueCachesActions.fetchUserSummary(personSummary?.creatorContributorId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personSummary?.creatorContributorId])

  if (isNullOrUndefined(personSummary) || isNullOrUndefined(personLabels)) {
    return null
  }

  return (
    <Grid>
      {/* Row */}
      <Cell columns={6}>
        <DataBlock
          heading={t('person.label', 'Person')}
          data={
            <>
              <PersonLink personId={personId} personName={personSummary?.summary?.name} showId newTab />
              <TreePersonLink personId={personId} treeIcon newTab />
            </>
          }
        />
      </Cell>
      <Cell columns={6}>
        <DataBlock
          heading={t('person.creatorContributor', 'Creator Contributor')}
          data={
            <UserLink userId={personSummary?.creatorContributorId} userName={userSummary?.contactName} showId newTab />
          }
        />
      </Cell>

      <TreeIdCells treeId={messageDetails?.treeId} isResearcherTree={messageDetails?.researcherTree} />

      {/* Row */}
      <OriginalAndStandardFactBlock heading={t('birth', 'Birth')} fact={personSummary?.birth} columns={6} />
      {/* Row */}
      <OriginalAndStandardFactBlock heading={t('death', 'Death')} fact={personSummary?.death} columns={6} />
      {/* Row */}
      <OriginalAndStandardFactBlock heading={t('burial', 'Burial')} fact={personSummary?.burial} columns={6} />
      {/* Row */}
      <LabelsBlock personLabels={personLabels} />
    </Grid>
  )
}
